import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button } from "@mui/material";

export default function ClearScheduleDialog({ open, onClose, onClear }) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Clear This Week's Schedule?</DialogTitle>
      <DialogContent>
        <Typography>
          <strong>Warning:</strong> This will remove <b>all shifts</b> from the current week. This action cannot be undone. Are you sure?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onClear} color="error" variant="contained">
          Yes, Clear All
        </Button>
      </DialogActions>
    </Dialog>
  );
}
